import React, { useEffect, useState } from "react";

import CustomIcons from "../../../components/icons/kIcons.component";
import { user_dash_list, user_deactivate, acknowledgeInternshipRanking } from "../user.api";
import DashApplicationDetails from "./components/application/dashApplication";
import CommonAppDetails from "./components/commonAppDetails/dashApplication";
import DashProfileDetails from "./components/profile/dashProfile";
import CompanyUsersDirectory from "../companyUsers/directory";
import "./mydash.css";
import "./dashboard.css";
import Loader from "../../../components/loader/loader";
import jwtDecode from "jwt-decode";
import ManageDeactivate from "./components/manage/manageDeactivate";
import Snackbar from "../../../components/snackbar/snackbar";
import DeactivatedInfo from "./components/manage/deativatedInfo";
import { Button, Modal } from "react-bootstrap";
import ResetPasswordModal from "../../../layout/userlayout/components/header/resetPasswordModal";

const quickLinks = [

  { name: "Trade Enquiries", link: "/trade-enquiries", icon: "activity" },
  {
    name: "Directory of Kerala companies affiliated with KSPACE",
    link: "/directory-kerala",
    icon: "newcompany",
  },
  { name: "Job Seeker Profiles", link: "/candidates", icon: "resource" },

  {
    name: "Directory of Aerospace institutions - India",
    link: "/directory-india",
    icon: "newcompany",
  },
  { name: "Internship Requests", link: "/internship-proposals", icon: "events" },


  {
    name: "Directory of Aerospace institutions - International",
    link: "/directory-international",
    icon: "newcompany",
  },
  {
    name: "Spacepark Advisors",
    link: "/advisors",
    icon: "advisors",
  },
  {
    name: "Directory of Academic Institutions",
    link: "/institute-list",
    icon: "academic",
  },
  {
    name: "Directory of Vendors",
    link: "/vendor-directory",
    icon: "directory",
  },
  { name: "Publications", link: "/publications", icon: "book" },

  {
    name: "Resource Personnel",
    link: "/resource-personal",
    icon: "user",
  },
  { name: "Challenges and Oppurtunities", link: "challenges-oppurtunities", icon: "challenges" },
  {
    name: "Technology Transfer Proposals",
    link: "/tech-transfer-proposal-list",
    icon: "directory",
  },
  {
    name: "Staff Management",
    link: "/directory-company-users",
    icon: "people",
  },






  // {
  //   name: "Expert Manpower",
  //   link: "/expert-manpower",
  //   icon: "user",
  // },


];

const applicationLinks = [
  {
    name: "Apply for New Company in KSPACE Premises",
    link: "/apply/new-company/kspace",
    icon: "building",
  },
  {
    name: "Apply for New Company in Own Premises",
    link: "/apply/new-company/own",
    icon: "house",
  },
  {
    name: "Affiliate Existing Aerospace Unit in Kerala",
    link: "/apply/register-kerala",
    icon: "company",
  },
  // {
  //   name: "Register Academic Institution",
  //   link: "/apply/institute-reg",
  //   icon: "user",
  // },
  // {
  //   name: "Register as Vendor",
  //   link: "/apply/vendors-reg",
  //   icon: "directory",
  // },
  // {
  //   name: "Register as Resource Personnel",
  //   link: "/apply/resource-personal-reg",
  //   icon: "user",
  // },
  // {
  //   name: "Register as Expert Manpower",
  //   link: "/apply/expert-manpower-reg",
  //   icon: "user",
  // },
  // {
  //   name: "Register as Job Seeker",
  //   link: "/apply/candidates-reg",
  //   icon: "resource",
  // },
];

export default function DashBoard(props) {
  const [activeMenu, setActiveMenu] = useState(() => {
    return sessionStorage.getItem("activeDashboardTab") || "application";
  });
  const [data, setdata] = useState([]);
  const [mainData, setMainData] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [appData, setAppData] = useState([]);
  const [url, setUrl] = useState("");
  const [open, setOpen] = useState(false);
  const [deactivatedInfo, setDeactivatedInfo] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [welcome, setWelcome] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const ProfVist = localStorage.getItem("profileVisit");


  const handleDash = () => {
    setIsActive(true);
    user_dash_list().then((res) => {
      setMainData(res);
      setdata(res.data);
      setIsActive(false);
      setUrl(res.current_url);

      if (res.internship_notifications) {
        setNotifications(res.internship_notifications);
      }

      const shouldPromptReset =
        sessionStorage.getItem("company_user_reset_password_prompt") === "1";
      const isCompanyUser =
        res?.data?.is_company_user === true ||
        res?.data?.user?.is_company_user === true ||
        userData?.is_company_user === true ||
        userData?.user?.is_company_user === true ||
        userData?.actor === "company_user";
      const shouldShowResetPrompt =
        Number(
          res?.data?.is_initial_login ??
          res?.data?.user?.is_initial_login ??
          userData?.is_initial_login ??
          userData?.user?.is_initial_login
        ) === 0;

      if (isCompanyUser && shouldPromptReset && shouldShowResetPrompt) {
        setWelcome(false);
        setShowResetPassword(true);
        sessionStorage.removeItem("company_user_reset_password_prompt");
      } else {
        setShowResetPassword(false);
        sessionStorage.removeItem("company_user_reset_password_prompt");
      }

      // Handle different data structures for different user types
      if (res?.data?.user_type === 21) {
        let feAdminUser = res.data;
        feAdminUser.status = 2;
        localStorage.setItem("app", JSON.stringify(feAdminUser));
        setAppData(res.data);
      } else if (res?.data?.is_company_user && res?.data?.company) {
        setAppData(res.data.company);
        localStorage.setItem("app", JSON.stringify(res.data.company));
      } else {
        setAppData(res.applications);
        localStorage.setItem("app", JSON.stringify(res.applications));
      }
    });
  };
  useEffect(() => {
    handleDash();
  }, []);
  const update = () => {
    props.history.push("/update-company");
  };
  const handleMenus = (menu) => {
    setActiveMenu(menu);
    sessionStorage.setItem("activeDashboardTab", menu);
  };

  let userData = jwtDecode(props.state.payload);
  const currentRole = Number(data?.user_type || userData?.user?.user_type);
  const filteredQuickLinks = currentRole === 27
    ? [
      { name: "Registered Internships", link: "/internship-applied", icon: "events" },
      { name: "Directory of Internships", link: "/public-internship-proposals", icon: "newcompany" }
    ]
    : quickLinks;

  const getStatusLabel = () => {
    const isCompany = data?.is_company_user || [0, 4, 5, 6].includes(Number(data?.user_type || userData?.user?.user_type));

    if (isCompany) {
      if (data?.is_company_user) {
        const s = data?.parent_company?.status !== undefined ? data?.parent_company?.status :
          mainData?.applications?.application_status !== undefined ? mainData?.applications?.application_status :
            data?.applicants?.application_status !== undefined ? data?.applicants?.application_status :
              appData?.application_status;

        if (s !== undefined && s !== null) {
          return s === 0 ? "Pending" :
            s === 1 ? "Submitted" :
              s === 2 ? "Approved" :
                s === 3 ? "In Progress" :
                  s === 5 ? "Reverted" :
                    s === 4 ? "Rejected" :
                      s === 6 ? "Agreement Execution" :
                        s === 7 ? "Ongoing Project" :
                          s === 8 ? "Completed" :
                            s === 16 ? "Waiting for company approval" :
                              s === 15 ? "Suggestion" : "";
        }
      }

      const s = appData?.application_status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Submitted" :
            s === 2 ? "Approved" :
              s === 3 ? "In Progress" :
                s === 5 ? "Reverted" :
                  s === 4 ? "Rejected" :
                    s === 6 ? "Agreement Execution" :
                      s === 7 ? "Ongoing Project" :
                        s === 8 ? "Completed" :
                          s === 16 ? "Waiting for company approval" :
                            s === 15 ? "Suggestion" : "";
      }
    }

    if ([9, 8, 10].includes(Number(data?.user_type || userData?.user?.user_type))) {
      const s = appData?.approval_status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Submitted" :
            s === 2 ? "Approved" :
              s === 3 ? "In Progress" :
                s === 5 ? "Reverted" :
                  s === 4 ? "Rejected" :
                    s === 6 ? "Agreement Execution" :
                      s === 7 ? "Ongoing Project" :
                        s === 8 ? "Completed" :
                          s === 16 ? "Waiting for company approval" :
                            s === 15 ? "Suggestion" : "";
      }
    }

    if (Number(data?.user_type || userData?.user?.user_type) === 20) {
      const s = appData?.status;
      if (s !== undefined && s !== null) {
        return s === 0 ? "Pending" :
          s === 1 ? "Submitted" :
            s === 2 ? "Accepted" :
              s === 3 ? "Reverted" :
                s === 5 ? "Rejected" :
                  s === 4 ? "Submitted" :
                    s === 9 ? "Deactivated" : "";
      }
    }

    if ([6, 5].includes(Number(data?.user_type || userData?.user?.user_type))) {
      const s = appData?.project_status;
      if (s !== undefined && s !== null) {
        return s === 0
          ? "Pending"
          : s === 1
            ? "Submitted for Acceptance"
            : s === 2
              ? "Approved"
              : s === 3
                ? "Super Admin Reverted"
                : s === 4
                  ? "Rejected"
                  : s === 5
                    ? "Reverted"
                    : "";
      }
    }
    return "";
  };

  const capitalizeFirst = (text) => {
    if (!text) return "";
    const str = text.toString();
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getHeaderName = () => {
    const ut = Number(data?.user_type || userData?.user?.user_type);
    if ([0, 4, 5, 6].includes(ut)) {
      return capitalizeFirst(
        ut === 4 && data?.is_company_user
          ? data?.parent_company?.name ||
          mainData?.applications?.company_name ||
          appData?.company_name ||
          "Company"
          : mainData?.applications?.company_name ||
          data?.company_name ||
          appData?.company_name ||
          "Company",
      );
    }
    if (ut === 9 || ut === 10) {
      return (appData?.first_name ? `${appData?.first_name} ${appData?.last_name || ""}` : "");
    }
    if (ut === 8) {
      return appData?.institution_name || "";
    }
    if (ut === 20) {
      return appData?.fname || appData?.name || (appData?.first_name ? `${appData?.first_name} ${appData?.last_name || ""}` : "");
    }
    if (ut === 24) {
      return appData?.company_name || data?.name || appData?.name || "";
    }
    if (ut === 27) {
      return appData?.full_name || appData?.name || "";
    }
    if (ut === 21) {
      return "Admin";
    }
    return "";
  };

  const getHeaderSub = () => {
    const ut = Number(data?.user_type || userData?.user?.user_type);
    switch (ut) {
      case 0:
      case 4:
      case 5:
      case 6:
        {
          const refNo = appData?.unique_application_ref_no ||
            data?.parent_company?.unique_application_ref_no ||
            data?.applicants?.unique_application_ref_no ||
            mainData?.applications?.unique_application_ref_no || "";
          if (refNo) {
            if (refNo.startsWith("KSPACE-PREMISES_")) {
              return "New Company in KSPACE Premises";
            }
            if (
              refNo.startsWith("KSPACE-OWN_") ||
              refNo.startsWith("KSPACE-GENERAL_")
            ) {
              return "New Company in Own Premises";
            }
            if (refNo.startsWith("KSPACE/E&IT/AFF/")) {
              return "Existing Aerospace Unit in Kerala";
            }
          }
          return "Aerospace Company / Unit";
        }
      case 8:
        return "Academic Institution";
      case 9:
        return "Resource Personnel";
      case 10:
        return "Expert Manpower";
      case 20:
        return "Job Seeker";
      case 21:
        return "Administrator";
      case 24:
        return "Vendor / Supplier";
      case 27:
        return "Student / Intern";
      default:
        return "KSPACE Affiliate User";
    }
  };

  const isCompany = (Number(data?.user_type || userData?.user?.user_type) === 0 ||
    Number(data?.user_type || userData?.user?.user_type) === 4 ||
    Number(data?.user_type || userData?.user?.user_type) === 5 ||
    Number(data?.user_type || userData?.user?.user_type) === 6 ||
    Number(data?.user_type || userData?.user?.user_type) === 21) &&
    !data?.is_company_user;

  const userType = data?.user_type || userData?.user?.user_type;

  const checkRevertOrReject = () => {
    const ut = Number(userType);

    // Check if affiliated company (role 5, company_type === "kerala", or token context_type === "company")
    const isAffiliated = ut === 5 ||
      data?.company_type === "kerala" ||
      data?.parent_company?.company_type === "kerala" ||
      userData?.context_type === "company" ||
      userData?.user?.context_type === "company";

    if (isAffiliated) {
      const s = appData?.application_status;
      return s === 4 || s === 5;
    }

    // For other company roles that are not affiliated: 0, 4, 6
    if ([0, 4, 6].includes(ut) || data?.is_company_user) {
      return false; // Non-affiliated companies do not show warning
    }

    // For non-company roles:
    // Resource (9), Expert (10), Academic (8), Student (27)
    if ([8, 9, 10, 27].includes(ut)) {
      const s = appData?.approval_status;
      return s === 4 || s === 5;
    }

    // Candidate (20)
    if (ut === 20) {
      const s = appData?.status;
      return s === 3 || s === 5;
    }

    // Vendor (24)
    if (ut === 24) {
      const s = appData?.status;
      return s === 6 || s === 7 || s === 8;
    }

    return false;
  };

  const hasActionNeeded = checkRevertOrReject();
  const isProfileUpdateRequired = hasActionNeeded && Number(userType) !== 0 && !data?.is_company_user;


  useEffect(() => {
    // If the active menu is 'users' but the loaded user is not a company, fall back to 'application'
    if (activeMenu === "users" && data?.user_type !== undefined && !isCompany) {
      setActiveMenu("application");
      sessionStorage.setItem("activeDashboardTab", "application");
    }
  }, [data, isCompany, activeMenu]);

  const isApplicationContext = userData?.context_type === "application" || userData?.user?.context_type === "application";

  const applicationId = (data?.is_company_user || [0, 4, 5, 6, 8].includes(Number(data?.user_type || userData?.user?.user_type)))
    ? (isApplicationContext
      ? data?.applicants?.unique_application_ref_no ||
      appData?.unique_application_ref_no ||
      mainData?.applications?.unique_application_ref_no ||
      data?.unique_application_ref_no
      : data?.parent_company?.unique_application_ref_no ||
      mainData?.applications?.unique_application_ref_no ||
      appData?.unique_application_ref_no ||
      data?.applicants?.unique_application_ref_no ||
      data?.unique_application_ref_no
    )
    : null;

  const getPath = (da) => {
    switch (Number(da)) {
      case 0:
        return "/update-company";

      case 4:
        return "/update-kspace";
      case 5:
        return "/update-kerala";
      case 6:
        return "/update-india";

      case 8:
        return "/update-academy";
      case 9:
        return "/update-resource";
      case 10:
        return "/update-manpower";
      case 20:
        return "/update-candidate";
      case 24:
        return "/vendor-registration";
      case 27:
        return "/training-reg";

      default:
        return "/";
    }
  };

  const handleQuickLinksNav = (link) => {
    props.history.push(link);
  };
  const updateProposal = (d) => {
    props.history.push(getPath(d));
  };
  const handleDeactivate = (id, fData) => {
    const data = {
      user_deactivate_message: fData.reason,
    };
    user_deactivate(id, data)
      .then((res) => {
        props.logout();
        props.history.push("/");
        // setOpen(false)
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };
  const handleClose = () => {
    setWelcome(false);
  };
  const handleNotificationClick = (id) => {
    setIsActive(true);
    acknowledgeInternshipRanking(id)
      .then((res) => {
        setIsActive(false);
        setNotifications((prev) => prev.filter((n) => n.id !== id));
        props.history.push(`/internship-proposals/${id}?tab=applications`);
      })
      .catch((err) => {
        setIsActive(false);
        props.history.push(`/internship-proposals/${id}?tab=applications`);
      });
  };
  useEffect(() => {
    const isCompanyUser =
      data?.is_company_user === true ||
      data?.user?.is_company_user === true ||
      userData?.is_company_user === true ||
      userData?.user?.is_company_user === true ||
      userData?.actor === "company_user";

    if ((!ProfVist || ProfVist < 1) && !isCompanyUser) {
      setWelcome(true);
    }
    localStorage.setItem("profileVisit", 1);
  }, [ProfVist, data?.is_company_user, data?.user, userData]);

  useEffect(() => {
    if (userData?.user?.user_type == 20 && appData?.status === 9) {
      setDeactivatedInfo(true);
    }
  }, [userData?.user?.user_type, appData?.status]);

  return (
    <>
      <div className="dash py-4" style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
        <Loader open={isActive} />

        <div className="container-fluid px-md-5 mt-4">
          {/* Master Header Card */}
          <div className="master-header-card mb-4">
            <div className="d-flex flex-column flex-lg-row align-items-center justify-content-between p-4 gap-4">
              {/* Leftside: Logo */}
              <div className="master-header-logo-wrapper">
                {appData?.logo ? (
                  <img
                    alt="logo"
                    src={
                      /^(https?:)?\/\//.test(appData?.logo)
                        ? appData?.logo
                        : url
                          ? `${url}/${appData?.logo}`
                          : appData?.logo
                    }
                    className="master-header-logo-img"
                  />
                ) : (
                  <div className="master-header-logo-placeholder">
                    {getHeaderName()?.substring(0, 1)?.toUpperCase() || "K"}
                  </div>
                )}
              </div>

              {/* Center: Details */}
              <div className="flex-grow-1 text-left text-start mx-lg-3">
                <h2 className="master-header-name mb-1">{getHeaderName()}</h2>
                <p className="master-header-sub mb-2">{getHeaderSub()}</p>
                {applicationId && (
                  <div className="mb-2">
                    <span className="master-header-ref-badge">
                      <i className="fa fa-hashtag mr-1" style={{ fontSize: "10px", opacity: 0.7 }}></i>
                      APPLICATION ID: {applicationId}
                    </span>
                  </div>
                )}
                <div className="d-flex flex-wrap justify-content-start gap-2">
                  {getStatusLabel() && (
                    <span className={`master-header-status-badge status-${getStatusLabel().toLowerCase().replace(/\s+/g, '-')}`}>
                      <span className="status-pulse-dot"></span>
                      {getStatusLabel()}
                    </span>
                  )}
                  {hasActionNeeded && (
                    <span
                      className="master-header-status-badge status-rejected blink"
                      style={{ cursor: "pointer", fontWeight: "bold" }}
                      onClick={() => updateProposal(userType)}
                    >
                      <i className="fa fa-exclamation-triangle mr-1"></i>
                      Action Required: {
                        Number(userType) === 5 ? (
                          appData?.application_status === 5
                            ? (appData?.user_message || "Reverted for modifications.")
                            : "Update profile details."
                        ) : [8, 9, 10, 27].includes(Number(userType)) ? (
                          appData?.approval_status === 5
                            ? (appData?.user_message || appData?.superadmin_message || "Reverted for modifications.")
                            : "Update profile details."
                        ) : Number(userType) === 24 ? (
                          "Vendor profile requires updates."
                        ) : Number(userType) === 20 ? (
                          "Update candidate application."
                        ) : "Update profile details."
                      }
                    </span>
                  )}
                </div>
              </div>

              {/* Rightside: Navigation Tabs */}
              <div className="master-header-tabs-container">
                <div className="master-header-tabs d-flex gap-2">
                  <button
                    className={`master-tab-btn ${activeMenu === "application" ? "active" : ""}`}
                    onClick={() => handleMenus("application")}
                  >
                    <i className="fa fa-th-large"></i>
                    Overview
                  </button>
                  <button
                    className={`master-tab-btn ${activeMenu === "profile" ? "active" : ""}`}
                    onClick={() => handleMenus("profile")}
                  >
                    <i className="fa fa-user"></i>
                    Detailed Profile
                  </button>
                  {isCompany && (
                    <button
                      className={`master-tab-btn ${activeMenu === "users" ? "active" : ""}`}
                      onClick={() => handleMenus("users")}
                    >
                      <i className="fa fa-users"></i>
                      Staff Management
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {notifications && notifications.length > 0 && (
            <div className="row mb-4">
              <div className="col-12">
                {notifications.map((notif) => (
                  <div
                    key={notif.id}
                    className="alert alert-info d-flex align-items-center justify-content-between p-4 shadow-sm"
                    style={{
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, rgba(0, 159, 227, 0.15) 0%, rgba(10, 34, 61, 0.05) 100%)",
                      border: "1px solid rgba(0, 159, 227, 0.25)",
                      color: "#0A223D",
                      fontFamily: "'Outfit', 'Poppins', sans-serif"
                    }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "50%",
                          background: "rgba(0, 159, 227, 0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#009fe3",
                          fontSize: "20px"
                        }}
                      >
                        <i className="fa fa-bell animate-bounce"></i>
                      </div>
                      <div>
                        <h5 className="mb-1" style={{ fontWeight: "700", fontSize: "16px", color: "#0A223D" }}>
                          Internship Ranking Update
                        </h5>
                        <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
                          KSAPCE has accepted and forwarded the internship request for{" "}
                          <strong>{notif.internship_discipline}</strong>. You can now review the applicant rankings.
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => handleNotificationClick(notif.id)}
                      className="btn btn-primary px-4 py-2"
                      style={{
                        borderRadius: "8px",
                        background: "linear-gradient(135deg, #009fe3 0%, #007bb0 100%)",
                        border: "none",
                        fontWeight: "600",
                        fontSize: "14px",
                        boxShadow: "0 4px 10px rgba(0, 159, 227, 0.2)"
                      }}
                    >
                      View Applications
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Main Dashboard Layout */}
          <div className="row">
            {activeMenu === "application" && (
              <>
                {/* Left side main content */}
                <div className="col-12 col-lg-8">
                  {/* Quick Links Section in left column (at the top) */}
                  <div className="sidebar-widget mb-4">
                    <h4 className="widget-title mb-3">Quick Links</h4>
                    <div className="row">
                      {filteredQuickLinks?.map((item, i) => (
                        <div className="col-12 col-sm-6 mb-2" key={i}>
                          <div
                            className="ql-list-item h-100"
                            onClick={() => {
                              handleQuickLinksNav(item?.link);
                            }}
                            style={{ marginBottom: 0 }}
                          >
                            <span className="ql-item-text">{item?.name}</span>
                            <span className="sub-ql">
                              <CustomIcons iconName={item.icon ?? "view"} />
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <DashApplicationDetails
                    data={
                      (data?.user_type === 0 || data?.user_type === 4) ||
                        (userData?.user?.user_type === 0 || userData?.user?.user_type === 4 || userData?.user?.user_type === 5 || userData?.user?.user_type === 6)
                        ? data?.is_company_user
                          ? data // For company users, pass the main user data object containing company and application info
                          : data?.applicants
                        : data
                    }
                    userType={data?.user_type || userData?.user?.user_type}
                    appData={appData}
                    url={url}
                    updateProposal={updateProposal}
                    dashMenu={props?.setDashMenuOpen}
                    handleMenus={handleMenus}
                    handleOpen={setOpen}
                    status={data?.application_status_message}
                    {...props}
                  />
                </div>

                {/* Right side sidebar content */}
                <div className="col-12 col-lg-4 mt-4 mt-lg-0">
                  {/* Submit New Applications Panel */}
                  {!data?.is_company_user && ([0, 4, 5].includes(userData?.user?.user_type) || [0, 4, 5].includes(userData?.user_type) || [0, 4, 5].includes(data?.user_type)) && (
                    <div className="sidebar-widget mb-4">
                      <h4 className="widget-title">Submit New Applications</h4>
                      <div className="mt-2">
                        {applicationLinks?.map((item, i) => (
                          <div
                            className="ql-list-item"
                            key={i}
                            onClick={() => {
                              handleQuickLinksNav(item?.link);
                            }}
                          >
                            <span className="ql-item-text">{item?.name}</span>
                            <span className="sub-ql">
                              <CustomIcons iconName={item.icon ?? "view"} />
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Messages Panel */}
                  <div className="sidebar-widget mb-4">
                    <h4 className="widget-title">Communication</h4>
                    <button
                      className="btn btn-primary btn-block d-flex align-items-center justify-content-center gap-2 py-3"
                      onClick={() => props.history.push("/kspace-messages")}
                      style={{
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        width: '100%',
                        border: 'none',
                        backgroundColor: '#0a223d'
                      }}
                    >
                      <i className="fa fa-envelope"></i>
                      KSPACE MESSAGES
                    </button>
                  </div>

                  {/* Opportunity to Advertise Your Product/Service on KSPACE Website */}
                  {(data?.user_type || userData?.user?.user_type) !== 30 && (
                    <div className="announcements-card p-4 mb-4">
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <span className="announcement-badge">NEW</span>
                        <h4 className="announcements-title mb-0" style={{ fontSize: "16px" }}>Opportunity to Advertise Your Product/Service on KSPACE Website</h4>
                      </div>

                      <div className="announcements-body">
                        <p className="intro-text" style={{ fontSize: "13px", lineHeight: "1.5" }}>
                          Greetings from KSPACE! We are pleased to inform you that you can now promote your products or services on the KSPACE website. Your advertisement will be displayed prominently, providing excellent visibility among industry professionals and visitors.
                        </p>

                        <div className="mt-3">
                          <div className="spec-box p-3 mb-3">
                            <h5 className="spec-title" style={{ fontSize: "13px", marginBottom: "8px" }}>
                              <i className="fa fa-image mr-2"></i>Advertisement Specifications
                            </h5>
                            <ul className="spec-list mb-0" style={{ paddingLeft: "15px", fontSize: "12px" }}>
                              <li><strong>Format:</strong> JPG / JPEG / PNG</li>
                              <li><strong>Size:</strong> 400px (width) &times; 250px (height)</li>
                            </ul>
                          </div>

                          <div className="spec-box p-3">
                            <h5 className="spec-title" style={{ fontSize: "13px", marginBottom: "8px" }}>
                              <i className="fa fa-tag mr-2"></i>Tariff (Exclusive of GST)
                            </h5>
                            <ul className="spec-list mb-0" style={{ paddingLeft: "15px", fontSize: "12px" }}>
                              <li><strong>1 Month:</strong> &#8377;2,000</li>
                              <li><strong>3 Months:</strong> &#8377;4,000</li>
                              <li><strong>6 Months:</strong> &#8377;6,000</li>
                              <li><strong>1 Year:</strong> &#8377;10,000</li>
                            </ul>
                          </div>
                        </div>

                        <div className="footer-notice mt-3 p-3 d-flex flex-column gap-2" style={{ fontSize: "12px" }}>
                          <span>
                            If you wish to advertise, please share your advertisement image in the specified format with our team at:
                            {" "}
                            <a href="mailto:info@kspace.org.in">info@kspace.org.in</a>
                          </span>
                          {(data?.user_type || userData?.user?.user_type) === 20 && appData?.status === 2 && (
                            <button
                              className="btn btn-outline-danger btn-sm mt-2 w-100"
                              onClick={() => setOpen(true)}
                            >
                              Deactivate Account
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}

            {activeMenu === "profile" && (
              <div className="col-12">
                <DashProfileDetails
                  data={appData}
                  userData={appData}
                  userType={data?.user_type || userData?.user?.user_type}
                  url={url}
                  handleMenus={handleMenus}
                  status={data?.application_status_message}
                  {...props}
                  userDetails={userData}
                  companyData={data?.is_company_user ? data : null}
                />
              </div>
            )}

            {activeMenu === "users" && (
              <div className="col-12">
                <CompanyUsersDirectory
                  {...props}
                  isDashboardTab={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <ManageDeactivate
        handleOpen={setOpen}
        open={open}
        appData={appData}
        handleDeactivate={handleDeactivate}
      />
      <DeactivatedInfo
        handleOpen={setDeactivatedInfo}
        open={deactivatedInfo}
        appData={appData}
      //  handleDeactivate={handleDeactivate}
      />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <ResetPasswordModal
        show={showResetPassword}
        onHide={() => setShowResetPassword(false)}
        token={props.state?.payload}
      />
      {welcome && (
        <Modal
          show={welcome}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body style={{
            padding: "2.5rem 2rem",
            borderRadius: "16px",
            border: "none",
            background: "#ffffff",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
            textAlign: "center"
          }}>
            {/* Spacepark Icon */}
            <div style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, rgba(0, 159, 227, 0.1) 0%, rgba(10, 34, 61, 0.05) 100%)",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "1.5rem",
              color: "#009fe3",
              fontSize: "36px",
              boxShadow: "0 4px 12px rgba(0, 159, 227, 0.15)",
              border: "1px solid rgba(0, 159, 227, 0.15)"
            }}>
              <i className="fa fa-space-shuttle" style={{ transform: "rotate(-45deg)" }}></i>
            </div>

            <h3 style={{
              fontFamily: "'Outfit', 'Poppins', sans-serif",
              fontWeight: "700",
              color: "#0A223D",
              fontSize: "24px",
              marginBottom: "0.5rem"
            }}>
              Welcome to KSPACE
            </h3>

            <p style={{
              fontFamily: "'Outfit', 'Poppins', sans-serif",
              fontSize: "14px",
              color: "#64748b",
              marginBottom: "2rem",
              lineHeight: "1.5"
            }}>
              We're glad to have you on board!
            </p>

            {/* Profile Info Card */}
            <div style={{
              background: "linear-gradient(135deg, #0A223D 0%, #1A365D 100%)",
              padding: "1.5rem",
              borderRadius: "12px",
              color: "#ffffff",
              marginBottom: "1.5rem",
              boxShadow: "0 4px 12px rgba(10, 34, 61, 0.15)",
              textAlign: "left",
              position: "relative",
              overflow: "hidden"
            }}>
              <div style={{
                position: "absolute",
                top: "-40px",
                right: "-40px",
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                background: "rgba(0, 159, 227, 0.2)",
                filter: "blur(20px)"
              }}></div>

              <div style={{ position: "relative", zIndex: 1 }}>
                <span style={{
                  fontSize: "11px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  color: "#009fe3",
                  display: "block",
                  marginBottom: "4px"
                }}>
                  Account Profile
                </span>
                <span style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  lineHeight: "1.3",
                  display: "block",
                  color: "#ffffff"
                }}>
                  {userData?.user?.company_name
                    ? userData?.user?.company_name
                    : userData?.user?.institution_name
                      ? userData?.user?.institution_name
                      : userData?.user?.name
                        ? userData?.user?.name
                        : userData?.user?.first_name
                          ? userData?.user?.first_name
                          : ""}
                </span>
              </div>
            </div>

            {/* Contact Details List */}
            <div style={{
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
              padding: "1.25rem",
              borderRadius: "12px",
              marginBottom: "2rem",
              textAlign: "left"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px",
                  backgroundColor: "rgba(10, 34, 61, 0.05)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#0A223D",
                  fontSize: "14px"
                }}>
                  <i className="fa fa-envelope"></i>
                </div>
                <div>
                  <label style={{
                    fontSize: "10px",
                    color: "#94a3b8",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    margin: 0,
                    display: "block"
                  }}>
                    Registered Email
                  </label>
                  <span style={{
                    fontSize: "13px",
                    color: "#334155",
                    fontWeight: "600"
                  }}>
                    {userData?.user?.email}
                  </span>
                </div>
              </div>

              <div style={{
                height: "1px",
                backgroundColor: "#e2e8f0",
                margin: "0.75rem 0"
              }}></div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px",
                  backgroundColor: "rgba(10, 34, 61, 0.05)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#0A223D",
                  fontSize: "14px"
                }}>
                  <i className="fa fa-phone"></i>
                </div>
                <div>
                  <label style={{
                    fontSize: "10px",
                    color: "#94a3b8",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    margin: 0,
                    display: "block"
                  }}>
                    Registered Mobile
                  </label>
                  <span style={{
                    fontSize: "13px",
                    color: "#334155",
                    fontWeight: "600"
                  }}>
                    {userData?.user?.mobile_number}
                  </span>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <button
              onClick={() => handleClose()}
              style={{
                width: "100%",
                padding: "12px 24px",
                background: "linear-gradient(135deg, #009fe3 0%, #007bb0 100%)",
                border: "none",
                borderRadius: "10px",
                color: "#ffffff",
                fontSize: "14px",
                fontWeight: "700",
                cursor: "pointer",
                boxShadow: "0 4px 14px rgba(0, 159, 227, 0.3)",
                transition: "all 0.2s ease-in-out",
                fontFamily: "'Outfit', 'Poppins', sans-serif"
              }}
            >
              Get Started
            </button>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
